import {createSlice} from "@reduxjs/toolkit";

const paginationSlice = createSlice({
    name: "paginationReducer",
    initialState: {
        dynamoMap : {},
    },
    reducers: {
        setDynamoMap(state, action) {
            state.dynamoMap = {...state.dynamoMap, ...action.payload};
        }
    }
});

export const paginationAction = paginationSlice.actions;

export default paginationSlice;